<script>

import Header from './components/Header'
import Nav from './components/Nav'
import Footer from './components/Footer'

const DtIndex = () => import('./pages/Index')
const DtTeam = () => import('./pages/Team')
const DtEvents = () => import('./pages/Events')
const DtPublications = () => import('./pages/Publications')
const DtContacts = () => import('./pages/Contacts')
const DtTmp = () => import('./pages/Tmp')

export default {
    name: 'dt',
    head: {
        title() {
            return {
                inner: this.isENG ? this.title : this.title_rus,
                separator: ' ',
                complement: ' ',
            }
        },
        meta() {
            return [
                {
                    name: 'keywords',
                    content: this.isENG? this.keywords:this.keywords_rus,
                },
                {
                    name: 'description',
                    content: this.isENG? this.description:this.description_rus,
                },
            ]
        },
        link: [
            {
                rel: 'icon',
                href: 'static/pictures/dt/logo/favicon.png',
                sizes: '16x16',
                type: 'image/png',
            },
        ],
    },
    components: {
        'dt-header': Header,
        'dt-nav': Nav,
        'dt-footer': Footer,
    },
    routes: [
        {name: 'dt-page-index',
            path: '',
            title: 'Home',
            title_rus: 'Главная',
            description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining',
            description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого',
            keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
            keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
            isInNav: true,
            component: DtIndex,
        },
        {name: 'dt-page-team',
            path: 'team/:id?',
            title: 'Team',
            title_rus: 'Команда',
            description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Team',
            description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Команда',
            keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
            keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
            isInNav: true,
            props: true,
            component: DtTeam,
        },
        {name: 'dt-page-events',
            path: 'events/:id?',
            title: 'Events',
            title_rus: 'События',
            description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Events',
            description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | События',
            keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov, megagrant, seminar, conference, staff',
            keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, мегагрант, семинары, штат лаборатории',
            isInNav: true,
            props: true,
            component: DtEvents,
        },
        {name: 'dt-page-publications',
            path: 'publications',
            title: 'Publications',
            title_rus: 'Публикации',
            description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Publications',
            description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Публикации',
            keywords: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, публикации, WoS, Scopus',
            keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров, мегагрант, семинары, штат лаборатории',
            isInNav: true,
            component: DtPublications,
        },
        {name: 'dt-page-contacts',
            path: 'contacts',
            title: 'Contacts',
            title_rus: 'Контакты',
            description: 'Skoltech | Laboratory of Prof. Andrzej Cichocki | Tensor networks and deep learning for applications in data mining | Contacts',
            description_rus: 'Сколтех | Лаборатория Тензорные сети и глубинное обучение для интеллектуального анализа данных под руководством доктора Анджея Чихоцкого | Контактная информация',
            keywords: 'Tensor networks, deep learning, neural networks, megagrant, skoltech, skolkovo, Andrzej Cichocki, Ivan Oseledets,  Victor Lempitsky,  Dmitry Vetrov',
            keywords_rus: 'Тензорные сети, глубинное обучение, глубокое обучение, нейронные сети, мегагрант, Сколтех, деревня Сколково, Анджей Чихоцкий, Иван Оселедец, Виктор Лемпицкий, Дмитрий Ветров',
            isInNav: true,
            component: DtContacts,
        },
        {name: 'dt-page-tmp',
            path: 'tmp',
            component: DtTmp,
        },
    ],
    data() {
        return {
            title: 'Deeptensor',
            title_rus: 'Deeptensor',
            description: 'Deeptensor',
            description_rus: 'Deeptensor',
            keywords: 'Deeptensor',
            keywords_rus: 'Deeptensor',
            routeDir: 'left',
        }
    },
    computed: {
        pages() {
            return this.$options.routes.filter(p => p.isInNav).map(p => ({
                name: p.name,
                title: this.isENG ? p.title : p.title_rus,
                params: p.params,
            }))
        },
    },
    created() {
        const page = this.$options.routes.find(p => p.name == this.$route.name)
        this.headUpdate(page)
    },
    beforeRouteUpdate(to, from, next) {
        const i1 = this.$options.routes.findIndex(p => p.name == from.name)
        const i2 = this.$options.routes.findIndex(p => p.name == to.name)
        const page = this.$options.routes.find(p => p.name == to.name)
        if(i1  > i2) this.routeDir = 'right'
        if(i1 == i2) this.routeDir = 'down'
        if(i1  < i2) this.routeDir = 'left'
        this.headUpdate(page)
        next()
    },
    methods: {
        headUpdate(page) {
            for(let prop of ['title', 'description', 'keywords'])
                for(let lang of ['', '_rus'])
                    this[prop+lang] = page[prop+lang]
            this.$emit('updateHead')
        },
    },
}
</script>

<template lang="pug">

v-app.dt
    dt-header.dt__header
    dt-nav.dt__nav(
        :pages="pages")
    div.dt__content
        transition(
            :name="'dt__content_'+routeDir"
            mode="out-in")
            keep-alive
                router-view
    dt-footer.dt__footer
</template>

<style lang="sass">

@import '~@dt/sass/root.sass'

html
    overflow-x: visible
    overflow-y: scroll
body
    position: relative
    width: 100%
    min-height: 100vh
    margin: 0
    overflow: scroll
    +padding(0 10px, $nano: 0 5px)
    +color-back(light1)
.dt
    overflow: scroll
    min-width: $width-min
    max-width: $width-max
    width: 100%
    margin: 0 auto
    +flex(column)
    +color-back(light1)
    &__content
        position: relative
        flex: 1 0 0
        +padding(15px 30px, $milli: 10px 20px, $nano: 7px 12px)
        +color(light, dark)
        +font(base)
        &_left-enter, &_right-enter, &_down-enter
            opacity: 0
        &_left-enter-active, &_right-enter-active, &_down-enter-active
            transition: opacity .4s
        &_left-leave-active, &_right-leave-active, &_down-leave-active
            transition: all .3s
        &_left-leave-to
            transform: translate(-120%, 0)
        &_right-leave-to
            transform: translate(120%, 0)
        &_down-leave-to
            transform: translate(0, 120%)
.button-shadow3d
    +flex(row, nowrap, center, center)
    +border(light)
    +color-font(dark3)
    +font(base-huge)
    &:hover
        +border(dark)
        +shadow(box3d-dark)
        +color-font(light3)
.dt-title
    +display(inline-block)
    +padding(10px 0 4px)
    +color-font(dark3)
    +font(base-bold-big)
    &_sub
        +padding(6px 0 2px)
        +color-font(dark2)
        +font(base-bold)
    &_pd
        +padding(10px 0 8px)
    &_3d
        +padding(20px 10px 20px 20px, $micro: 15px 30px 15px 80px, $nano: 10px 20px 10px 50px)
        +shadow(box3d-dark)
        +color(light1, dark3)
        +font(base-huge)
    &_3d-wide
        +padding(20px 50px 20px 100px, $micro: 15px 30px 15px 80px, $nano: 10px 20px 10px 50px)
        +shadow(box3d-dark)
        +color(light1, dark3)
        +font(base-huge)
.dt-link
    +color-font(dark)
    +font(base)
    text-decoration: underline
    cursor: pointer
    &:hover
        +color-font(light3)
        text-decoration: none
        cursor: pointer
.dt-em
    +color-font(light3)
    +font(base)
    text-align: left
    &_spec
        +color-font(dark3)
        +font(base-italic)
    &_right
        text-align: right
.dt-text
    +margin(5px 0 1px)
    +color-font(dark)
    +font(base)
    text-align: justify
.dt-string
    +margin(3px 0 1px)
    +color-font(dark)
    +font(base)
    text-align: left
</style>



// WEBPACK FOOTER //
// site/deeptensor/Deeptensor.vue